import { useContext } from 'react';
import { ListNavigationStateContext } from '@/contexts/ListNavigationStateContext';

export const useListNavigationStateContext = () => {
  const context = useContext(ListNavigationStateContext);
  
  if (!context) {
    throw new Error('useListNavigationStateContext must be used within a ListNavigationStateContextProvider');
  }
  
  return context;
};
